export default "__VITE_ASSET__CTp1vaaR__"